module.exports = __webpack_public_path__ + "img/menu.5a4f3945.svg";